import { Type } from 'class-transformer';

export class CommunitySelectorResultDto {
    communityId: number;
    communityName: string;
    intacctCompanyId: string;
    locationId: number;
    locationName: string;
    managementCompanyId: number;
    managementCompanyName: string;
    satelliteOfficeId: number;
    satelliteOfficeName: string;
    status: string;
    active: boolean;
    @Type(() => Date)
    terminatingDate: Date;

    get isTerminating(): boolean {
        // Could not use Utils. As the expected output differs.
        return this.terminatingDate ? true : false;
    }

    // Transient
    searchExpression: string;
    get context(): string {
        return `C${this.communityId}`;
    }

    get isActive(): boolean {
        return this.status !== 'Terminated';
    }

    get displayText(): string {
        return `${this.communityName}; ${this.locationName}; ${this.status}`;
    }
}
